export const initState = {
	localTimes: {},
	localTimesList: [],
	filteredList: [],
	_localTimes: 'init',
};

export default initState;
